// routesConfig.js
import HomePage from '../components/HomePage';
import LoginPage from '../components/LoginPage';
import RegisterPage from '../components/RegisterPage';
import CustomerPage from '../components/Customer';
import ProjectsPage from '../components/Projects';
import CreateProjectPage from '../components/CreateProjectPage';
import CustomerInfo from '../components/CustomerInfo';
import ProjectInfo from '../components/ProjectInfo';
import InvoiceInfo from '../components/InvoiceInfo';
import ReportInfo from '../components/ReportInfo';
import TimeTracking from '../components/TimeTracking';
import QuotesPage from '../components/Quotes';
import QuoteInfo from '../components/QuoteInfo';
import ContractsPage from '../components/ContractsPage';
import InvoicesPage from '../components/InvoicesPage';
import ReportsPage from '../components/ReportsPage';
import ContractInfo from '../components/ContractInfo';
import SignContractPage from '../components/SignContractPage';
import SignPage from '../components/SignPage';
import SignReportPage from '../components/SignReportPage';
import MyAccountPage from '../components/MyAccountPage';
import ServicesPage from '../components/ServicesPage';
import ServiceInfoPage from '../components/ServiceInfoPage';
import InventoryPage from '../components/InventoryPage';
import InventoryInfo from '../components/InventoryInfo';
import UsersPage from '../components/UsersPage';
import UsersInfoPage from '../components/UserInfoPage';
import EmployeesPage from '../components/EmployeesPage';
import EmployeeInfoPage from '../components/EmployeeInfoPage';
import MyAbsencesPage from '../components/MyAbsencesPage';
import PublicHolidaysPage from '../components/PublicHolidaysPage';
import PlannerPage from '../components/PlannerPage';
import FieldReportsPage from '../components/FieldReportsPage';
import SetupAccountPage from '../components/SetupAccountPage';
import PricingPage from '../components/PricingPage';
import ManageSubscriptionPage from '../components/ManageSubscriptionPage';
import SubscriptionSuccessPage from '../components/SubscriptionSuccessPage';
import PortalLoginPage from '../components/portal/PortalLoginPage';
import PortalSetupAccountPage from '../components/portal/PortalSetupAccountPage';
import PortalQuotesPage from '../components/portal/PortalQuotesPage';
import PortalQuoteDetailPage from '../components/portal/PortalQuoteDetailPage';
import PortalContractsPage from '../components/portal/PortalContractsPage';
import PortalContractDetailPage from '../components/portal/PortalContractDetailPage';
import PortalInvoicesPage from '../components/portal/PortalInvoicesPage';
import PortalProjectsPage from '../components/portal/PortalProjectsPage';
import PortalProjectDetailPage from '../components/portal/PortalProjectDetailPage';
import PortalAuthGuard from '../components/portal/PortalAuthGuard';
import InvoiceStylePage from '../components/InvoiceStylePage';
import Roles from '../config/roles';

const routesConfig = [
    { path: '/portal/login', element: <PortalLoginPage />, public: true },
    { path: '/portal/setup-account', element: <PortalSetupAccountPage />, public: true },
    { path: '/portal/quotes', element: <PortalAuthGuard><PortalQuotesPage /></PortalAuthGuard>, public: true },
    { path: '/portal/quotes/:id', element: <PortalAuthGuard><PortalQuoteDetailPage /></PortalAuthGuard>, public: true },
    { path: '/portal/contracts', element: <PortalAuthGuard><PortalContractsPage /></PortalAuthGuard>, public: true },
    { path: '/portal/contracts/:id', element: <PortalAuthGuard><PortalContractDetailPage /></PortalAuthGuard>, public: true },
    { path: '/portal/invoices', element: <PortalAuthGuard><PortalInvoicesPage /></PortalAuthGuard>, public: true },
    { path: '/portal/projects', element: <PortalAuthGuard><PortalProjectsPage /></PortalAuthGuard>, public: true },
    { path: '/portal/projects/:id', element: <PortalAuthGuard><PortalProjectDetailPage /></PortalAuthGuard>, public: true },
    { path: '/login', element: <LoginPage />, public: true },
    { path: '/register', element: <RegisterPage />, public: true },
    { path: '/sign/:token', element: <SignPage />, public: true },
    { path: '/sign-contract/:token', element: <SignContractPage />, public: true },
    { path: '/sign-report/:id', element: <SignReportPage />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/field', element: <FieldReportsPage />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/pricing', element: <PricingPage />, roles: [Roles.ADMIN] },
    { path: '/subscription/success', element: <SubscriptionSuccessPage />, public: true },
    { path: '/manage-subscription', element: <ManageSubscriptionPage />, roles: [Roles.ADMIN] },
    { path: '/home', element: <HomePage />, roles: [Roles.ADMIN] },
    { path: '/customers', element: <CustomerPage />, roles: [Roles.ADMIN] },
    { path: '/customers/:id', element: <CustomerInfo />, roles: [Roles.ADMIN] },
    { path: '/create-project', element: <CreateProjectPage />, roles: [Roles.ADMIN] },
    { path: '/customer-info', element: <CustomerInfo />, roles: [Roles.ADMIN] },
    { path: '/planner', element: <PlannerPage />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/projects', element: <ProjectsPage />, roles: [Roles.ADMIN] },
    { path: '/project-info/:id', element: <ProjectInfo />, roles: [Roles.ADMIN] },
    { path: '/invoices', element: <InvoicesPage />, roles: [Roles.ADMIN] },
    { path: '/invoices/:id', element: <InvoiceInfo />, roles: [Roles.ADMIN] },
    { path: '/reports', element: <ReportsPage />, roles: [Roles.ADMIN] },
    { path: '/reports/:id', element: <ReportInfo />, roles: [Roles.ADMIN] },
    { path: '/time-tracking', element: <TimeTracking />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/absences', element: <MyAbsencesPage />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/quotes', element: <QuotesPage />, roles: [Roles.ADMIN] },
    { path: '/quote-info/:id', element: <QuoteInfo />, roles: [Roles.ADMIN] },
    { path: '/contracts', element: <ContractsPage />, roles: [Roles.ADMIN] },
    { path: '/contracts/:id', element: <ContractInfo />, roles: [Roles.ADMIN] },
    { path: '/settings', element: <MyAccountPage section="profile" />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/account/profile', element: <MyAccountPage section="profile" />, roles: [Roles.ADMIN, Roles.USER] },
    { path: '/account/company', element: <MyAccountPage section="company" />, roles: [Roles.ADMIN] },
    { path: '/account/subscription', element: <MyAccountPage section="subscription" />, roles: [Roles.ADMIN] },
    { path: '/invoice-style', element: <InvoiceStylePage />, roles: [Roles.ADMIN] },
    { path: '/inventory', element: <InventoryPage />, roles: [Roles.ADMIN] },
    { path: '/inventory/:id', element: <InventoryInfo />, roles: [Roles.ADMIN] },
    { path: '/services', element: <ServicesPage />, roles: [Roles.ADMIN] },
    { path: '/services/:id', element: <ServiceInfoPage />, roles: [Roles.ADMIN] },
    { path: '/employees', element: <EmployeesPage />, roles: [Roles.ADMIN] },
    { path: '/employees/:id', element: <EmployeeInfoPage />, roles: [Roles.ADMIN] },
    { path: '/public-holidays', element: <PublicHolidaysPage />, roles: [Roles.ADMIN] },
    { path: '/setup-account', element: <SetupAccountPage />, public: true },
    { path: '/users', element: <UsersPage />, roles: [Roles.ADMIN] },
    { path: '/users/:id', element: <UsersInfoPage />, roles: [Roles.ADMIN] },
];

export default routesConfig;
